import React, { Suspense } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import LandingLayout from '../containers/LandingLayout';
import LoadingIndicator from 'components/LoadingIndicator';

interface LandingLayoutRouteProps extends RouteProps {
  component: any;
}

export default function ({ component: Component, ...rest }: LandingLayoutRouteProps) {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <LandingLayout>
          <Suspense fallback={<LoadingIndicator />}>
            <Component {...matchProps} />
          </Suspense>
        </LandingLayout>
      )}
    />
  );
}
